<template>
  <footer class="footer">
    <div class="content-wrapper">
      <Logo class="logo" />
      <div class="rights">
        <p>© ООО “Байторг Бай”, 2024</p>
        <p>
          Копирование материалов запрещено. При согласованном использовании
          материалов сайта необходима ссылка на ресурс.
        </p>
      </div>
      <div class="links">
        <router-link
          exact
          target="_blank"
          rel="noopener noreferrer"
          :to="privacyPolicyPath"
          class="new-footer-link"
        >
          Политика конфиденциальности
        </router-link>
        <router-link
          exact
          target="_blank"
          rel="noopener noreferrer"
          :to="termsOfUsePath"
          class="new-footer-link"
        >
          Правила пользования
        </router-link>
        <router-link
          exact
          target="_blank"
          rel="noopener noreferrer"
          :to="cookiePath"
          class="new-footer-link"
        >
          Политика обработки файлов cookie
        </router-link>
        <span class="new-footer-link" @click="openCookieBanner">
          Настройки cookie
        </span>
      </div>
      <div class="contacts">
        <div class="contact-container">
          <Phone class="icon" />
          <a
            target="_blank"
            rel="noopener noreferrer"
            class="footer-contacts-item-link"
            href="tel:+375447228833"
            >+375 44 722-88-33
          </a>
        </div>
        <div class="contact-container">
          <Email class="icon" />
          <a class="footer-contacts-item-link" href="mailto:office@bytorg.by"
            >office@bytorg.by
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Phone from "@/assets/icons/phone.svg";
import Email from "@/assets/icons/email.svg";
import Logo from "@/assets/icons/new-logo.svg";
import { termsOfUsePath } from "@/router/termsOfUse";
import { privacyPolicyPath } from "@/router/privacyPolicy";
import { cookiePath } from "@/router/cookie";
import { eventBus } from "@/main";

export default {
  name: "Footer",
  components: { Phone, Email, Logo },
  data() {
    return { termsOfUsePath, privacyPolicyPath, cookiePath };
  },
  methods: {
    openCookieBanner() {
      eventBus.$emit("openCookieBanner");
    },
  },
};
</script>

<style scoped lang="less">
.footer {
  background-color: #484e55;
  height: 334px;
  padding: 50px 0;
  @media (max-width: 1480px) {
    padding: 50px 20px;
  }
  @media (max-width: 1439px) {
    padding: 24px 20px;
    height: 320px;
  }
  @media (max-width: 767px) {
    padding: 24px 10px;
    height: auto;
  }

  .content-wrapper {
    margin: 40px 0;
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      "logo links"
      "rights contacts";
    max-width: 1440px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    @media (max-width: 1439px) {
      grid-template-columns: 1fr 1fr;
    }

    .logo {
      grid-area: logo;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      width: 168px;
      height: 80px;
      @media (max-width: 767px) {
        width: 80px;
        height: 38px;
      }
    }
    .rights {
      grid-area: rights;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      font-family: Montserrat;
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 1;
      color: #ffffff;
      @media (max-width: 1439px) {
        font-family: Montserrat;
        font-weight: 500;
        font-size: 16px;
        line-height: 1;
      }
      @media (max-width: 767px) {
        font-family: Montserrat;
        font-weight: 500;
        font-size: 14px;
        line-height: 1;
      }
    }
    .links {
      grid-area: links;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;
      gap: 12px;
      @media (max-width: 767px) {
        align-items: start;
        gap: 8px;
      }

      .new-footer-link {
        font-family: Montserrat;
        font-weight: 500;
        font-style: Medium;
        font-size: 20px;
        line-height: 1;
        color: white;
        text-decoration: none;
        cursor: pointer;
        &:hover {
          color: #a5d8ff;
        }
        @media (max-width: 1439px) {
          font-family: Montserrat;
          font-weight: 500;
          font-size: 16px;
          line-height: 1;
        }
        @media (max-width: 767px) {
          font-family: Montserrat;
          font-weight: 500;
          font-size: 14px;
        }
      }
    }
    .contacts {
      grid-area: contacts;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;
      gap: 12px;
      @media (max-width: 767px) {
        gap: 4px;
      }
      .contact-container {
        display: flex;
        gap: 10px;
        align-items: center;
        justify-content: center;
        .icon {
          width: 21px;
          height: 21px;
          @media (max-width: 767px) {
            width: 16px;
            height: 16px;
          }
        }
        .footer-contacts-item-link {
          font-family: Montserrat;
          font-weight: 500;
          font-style: Medium;
          font-size: 24px;
          line-height: 1;
          color: white;
          text-decoration: none;
          &:hover {
            cursor: pointer;
            color: #a5d8ff;
          }
          @media (max-width: 1439px) {
            font-family: Montserrat;
            font-weight: 500;
            font-size: 18px;
            line-height: 1;
          }
          @media (max-width: 767px) {
            font-family: Montserrat;
            font-weight: 500;
            font-size: 16px;
          }
        }
        &:nth-child(2) {
          margin-right: 10px;
          @media (max-width: 1439px) {
            margin-right: 7px;
          }
        }
      }
    }
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      grid-template-rows: repeat(4, fit-content);
      gap: 24px;
      grid-template-areas:
        "logo"
        "links"
        "contacts"
        "rights";
      justify-items: start;
    }
  }
}
</style>
